import React, { Component } from 'react';
import '../../../styles/variables.css';
import {Row, Col} from 'react-bootstrap';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import profile from '../../../images/profile.png';
import './Profile.css';
import ModalUserInfo from '../../../components/ModalUser';
import ModalUserCv from '../../../components/ModalUserCv';
import {connect} from 'react-redux';
import {NotificationContainer} from 'react-notifications';
import Loader from '../../../components/loader'

class Profile extends Component {

    state = {
        link: 'pers',
        showModalInfo: false,
        showModalCv: false,
        renderModal: false,
        loader: false,
        info: {
            id: '',
            name: '',
            lastName: '',
            cv: '',
            email: '',
            existCv: false,
            experience: '',
            expertise: '',
            locationName: '',
            phoneNumber:'',
            career: '',
            aboutMe: ''
        }
    }

    componentDidMount(){
        this.getData();
    }
    getData = () => {        
    this.setState({
        info:{
            id: this.props.student.profile.id,
            name: this.props.student.profile.name,
            lastName: this.props.student.profile.lastName,
            cv: this.props.student.profile.cv,
            email: this.props.student.profile.email,
            existCv: this.props.student.profile.existCv,
            experience: this.props.student.profile.experience,
            expertise: this.props.student.profile.expertise,
            locationName: this.props.student.profile.locationName,
            phoneNumber: this.props.student.profile.phoneNumber,
            aboutMe: this.props.student.profile.aboutMe,
            career: this.props.student.profile.career
        },
        renderModal: true
        })
    }
    ToggleModal = () => {
        this.setState(prevState => ({
            showModalInfo: !prevState.showModalInfo,
            renderModal: !prevState.renderModal
        }));
        this.getData()
    }

    ToggleModalCv = () => {
        this.setState(prevState => ({
            showModalCv: !prevState.showModalCv,
            renderModal: !prevState.renderModal
        }));
        this.getData();
    }

    showLoader = () => {
        this.setState(prevState => ({
            loader: !prevState.loader
        }));
    }

    render(){
        return(
            <div className="container">
                <Row><Header {...this.props}/></Row>
                <Row>
                    <Col className="p-none" xs={12} sm={12} md={3} lg={3} xl={3}>
                        <div className="profile-side">
                            <img className="profile-image" src={profile} alt="user-profile"/>
                            <div className="profile-resume">
                                <p className="user-info">{this.state.info.name} {this.state.info.lastName}</p>
                                <p className="user-info">{this.state.info.phoneNumber}</p>
                                <p className="user-info">{this.state.info.email}</p>
                                {this.state.info.existCv ? <a href={this.state.info.cv} target="_blank" rel="noopener noreferrer" className="user-cv">Mi cv</a> : null}
                            </div>
                            <div className="user-actions">
                                <p className="general-text-profile"> ¿Hay algo nuevo? </p>
                                <button className="update-cv" onClick={() => this.setState({showModalCv : true}) }>Actualizar mi CV</button>
                                <p className="general-text-profile"> o </p>
                                <button className="update-cv" onClick={() => this.setState({showModalInfo: true})}>Actualizar mi información</button>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={9} lg={9} xl={9}>
                        <div className="info-side">
                            <p className="up-title">Resumen</p>
                            <div className="up-more-about us-op-active">
                                <p className="more-user-info">Carrera</p>
                                <p className="more-user-info">Especialidad</p>
                                <p className="more-user-info">Ubicación</p>
                            </div>
                            <div className="up-more-about">
                                <p className="more-user-info-r">{this.state.info.career}</p>
                                <p className="more-user-info-r">{this.state.info.expertise}</p>
                                <p className="more-user-info-r">{this.state.info.locationName}</p>
                            </div>
                            <div className="user-profile-options">
                                <p className={`user-profile-option ${this.state.link=== "pers" ? "us-op-active":""}`} 
                                onClick={() => this.setState({link:"pers"})}>Personal</p>
                                <p className={`user-profile-option ${this.state.link=== "prof" ? "us-op-active":""}`} 
                                onClick={() => this.setState({link:"prof"})}>Profesional</p>
                            </div>
                            <div className="user-profile-main">
                                <div className={`up-card ${this.state.link=== "pers" ? "up-card-active":""}`} >
                                    <p className="up-title">Acerca de mí...</p>
                                    <p className="up-about-me">
                                        {this.state.info.aboutMe}
                                    </p>
                                </div>
                                <div className={`up-card ${this.state.link=== "prof" ? "up-card-active":""}`} >
                                    <p className="up-title">Mi experiencia...</p>
                                    <p className="up-about-me">
                                        {this.state.info.experience}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                {this.state.renderModal ? 
                <ModalUserInfo data={this.state.info} 
                open={this.state.showModalInfo} close={this.ToggleModal}/>
                 : null}
                {this.state.renderModal ? 
                <ModalUserCv loader={this.showLoader} open={this.state.showModalCv} close={this.ToggleModalCv}/> : null}
                <Row><Footer /></Row>
                <NotificationContainer />
                <Loader active={this.state.loader}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    id: state.auth.uid,
    student: state.student
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);